<template>
  <div :style="$cmsStyles('c_412233bb1611')" class="media-container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="media-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_412233bb1611', 'f_0001', true)" class="banner-wrapper"></div>
        <div class="common-content-wrapper content-wrapper">
          <div v-show="$cms('c_412233bb1611', 'f_0002', true)" class="box-1">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_412233bb1611', 'f_0003', "品牌介绍") }}</h2>
              <div class="box-header-desc">{{ $cms('c_412233bb1611', 'f_0004', "Brand  Introduction") }}</div>
            </div>
            <div class="box-content">
              <div class="desc">{{ $cms('c_412233bb1611', 'f_0005', "可立克") }}<br />{{ $cms('c_412233bb1611', 'f_0006', "") }}<br />{{ $cms('c_412233bb1611', 'f_0007', "") }}</div>
            </div>
          </div>


          <div v-show="$cms('c_412233bb1611', 'f_0008', true)" class="box-3">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_412233bb1611', 'f_0009', "品牌定位") }}</h2>
              <div class="box-header-desc">{{ $cms('c_412233bb1611', 'f_0010', "Brand Positioning") }}</div>
            </div>
            <div class="box-content">
             
            </div>
          </div>

          <div v-show="$cms('c_412233bb1611', 'f_0011', true)" class="box-7">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_412233bb1611', 'f_0012', "产品介绍") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_412233bb1611', 'f_0013', "Product Introduction") }}</div>
              <div class="box-header-desc">{{ $cms('c_412233bb1611', 'f_0014', "可立克") }}</div>
            </div>
            <div class="box-content">
              <div class="band-btns">
                <div class="btn" v-for="btn in brandBtns" :key="btn">{{ btn }}</div>
              </div>
              <div class="band-group-list">
                <div class="group-item" v-for="item in brandGroupList" :key="item.type">
                  <div class="group-title">{{ item.type }}</div>
                  <div class="group-item-list">
                    <div class="item" v-for="listItem in item.list" :key="listItem.name">
                      <div class="item-img">
                        <img :src="listItem.img" loading="lazy" :alt="listItem.name">
                      </div>
                      <div class="item-info">
                        <div class="item-name">{{ listItem.name }}</div>
                        <div class="item-desc">{{ listItem.desc }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <BrandCooperationBox />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue';
import BrandCooperationBox from '@/components/brand/BrandCooperationBox.vue';

export default {
  components: {
    ToolsBar,
    BrandCooperationBox,
  },
  head() { return this.$cmsHead('c_412233bb1611', {
    title: '可立克|魔筷科技',
    meta: [
      { name: 'Keywords', content: '可立克,魔筷科技' },
      { name: 'Description', content: '可立克品牌介绍与产品展示。' },
    ],
  }); },
  data() {
    return {
      brandBtns: this.$cms('c_412233bb1611', 'f_0015', ["全部产品", "经典系列", "功效系列", "香氛系列", "PVC系列", "牙刷系列"]),
      brandGroupList: this.$cms('c_412233bb1611', 'f_0016', [{"type":"经典系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/0f151371-3d8e-4d41-9c98-a045edfc5b3e.png","name":"备长炭","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/22ddb316-4894-48de-8576-3ad717c4bbed.png","name":"备长炭大规格","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/1c7ee519-a505-4aa4-a211-82e7df617571.png","name":"御龈清新","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/1eb36912-a426-433a-8ed3-b2ad8637acf8.png","name":"御龈清新大规格","desc":""}]},{"type":"功效系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/347a146e-c2af-4293-8a11-8f64ac8d4913.png","name":"酵素美白","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/b0012254-6656-4911-87af-eccf68bec33a.png","name":"冷光修白","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/9236a93b-72cd-44f0-aaaf-2c0e21d5eb7b.png","name":"三重薄荷","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/d7176a98-d94e-4c8d-aa55-d4319466a76d.png","name":"椰油小苏打","desc":""}]},{"type":"香氛系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/e2821990-90cc-4305-aa63-04348aad96f5.png","name":"瓷光润白","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/35803e33-1f62-400d-a1ba-373d0e46c533.png","name":"皓齿净白","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/f3ecee3c-12ce-42d4-b4d3-e8d979b77186.png","name":"减少口臭","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/02c59f80-efc7-4f59-87f8-d690b7300a84.png","name":"净澈亮白","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/0b817769-0021-4e97-b2d4-a0e8b62076e9.png","name":"清新口气","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/3f12a3f1-97f8-436a-9c2d-c63537d68273.png","name":"钻石耀白","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/a259114a-dd21-4faa-99f4-501065534422.png","name":"双效炫白（晨露西柚）","desc":"105g"},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/bd81cd7e-ded3-45b9-9aa0-61effcfb1e9c.png","name":"双效炫白（初雪茉莉）","desc":"105g"},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/46a58c00-3a52-47f2-b282-bf506680eadc.png","name":"双效炫白（桂花乌龙）","desc":"105g"},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/28f3c2dc-0412-4413-a62b-7f63ffa7f739.png","name":"双效炫白（雪沁白桃）","desc":"105g"},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/dcffc707-018e-4f16-8faf-b9380b238e9d.png","name":"双效炫白（雨润青提）","desc":"105g"},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/d947b947-7485-475f-9881-530b77e7619f.png","name":"双效炫白（云雾白茶）","desc":"105g"}]},{"type":"PVC系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/33f0780a-ccef-4cd6-b55f-fa7d34c19587.png","name":"沸石美白牙膏","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/32736031-bd14-40c0-8255-e2db50d23dbf.png","name":"抗牙结石牙膏","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/c81f44a2-bf00-481c-9f40-a883e0503015.png","name":"粒粒爽牙膏","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/e2fcd02c-774d-4bc9-b542-764b3f9f1720.png","name":"磨粒迅白牙膏","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/8eb3ad81-99e6-49f5-b710-b5fbe13556dd.png","name":"羟基磷灰石牙膏","desc":""}]},{"type":"牙刷系列","list":[{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/789c1413-8ce1-453a-97b8-afa0bd471aae.png","name":"多巴胺系列牙刷（单支/双支）","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/d5a11ba4-744a-4576-a587-752211fb59f9.png","name":"蜂巢系列牙刷（单支/双支）","desc":""},{"img":"https://mk-crm-cdn.mockuai.com/home/ssr-admin/a6458abd-56b1-4ade-ada9-e4099b5edea9.png","name":"纤柔牙刷（2支）","desc":""}]}]),
    }
  },
  mounted() {
    // this.initFullpage()
    this.$refs.toolsBar.show()
  },
  methods: {
   
  },
}
</script>

<style lang="less" scoped>
@import "../../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-image: var(--cms-c_412233bb1611-f_0017, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250910172245410000552.17574961652571422.jpg?x-oss-process=image/quality,Q_80"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
    }
  }
  .content-wrapper {
    .box-1 {
      background: #FFF;
      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 60);
        .pxToVw(width, 1440);
        .pxToVw(height, 754);
        background-image: var(--cms-c_412233bb1611-f_0018, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250915191902110000937.17579351419654685.png"));
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
        position: relative;
        .pxToVw(padding-top, 260);
        .pxToVw(padding-left, 118);
        .desc {
          .pxToVw(width, 620);
          font-weight: 400;
          .pxToVw(font-size, 24);
          .pxToVw(line-height, 40);
          color: #666666;
        }
      }
    }


    .box-3 {
      background: #FFF;
      .box-content {
        .pxToVw(margin-top, 80);
        .pxToVw(width, 1920);
        .pxToVw(height, 1080);
        background-image: var(--cms-c_412233bb1611-f_0019, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250910171931670000629.17574959714865805.jpg?x-oss-process=image/quality,Q_80"));
        background-size: cover;
        background-repeat: no-repeat;
      }
    }

    .box-7 {
      background: #FFF;
      .pxToVw(padding-bottom, 80);
      .band-btns {
        display: flex;
        flex-wrap: wrap;
        margin: 0 auto;
        .pxToVw(width, 1440);
        justify-content: center;
        .pxToVw(gap, 30);
        .pxToVw(padding-top, 60);
        .pxToVw(padding-bottom, 60);
        .btn {
          .pxToVw(width, 210);
          .pxToVw(height, 48);
          .pxToVw(border-radius, 30);
          .pxToVw(font-size, 18);
          .pxToVw(line-height, 25);
          box-sizing: border-box;
          font-weight: 400;
          color: #333333;
          border: 1px solid #999999;
          display: flex;
          align-items: center;
          justify-content: center;

          &:first-child {
            background: linear-gradient( 90deg, #FF6600 0%, #FC4440 100%);
            border: none;
            color: #fff;
          }
        }
      }

      .band-group-list {
        display: flex;
        flex-wrap: wrap;
        .pxToVw(padding-top, 80);
        .pxToVw(width, 1440);
        margin: 0 auto;
        .pxToVw(gap, 30);
        .group-title {
          font-weight: 600;
          .pxToVw(font-size, 30);
          .pxToVw(line-height, 42);
          .pxToVw(margin-bottom, 30);
          color: #333333;
        }
        .group-item {
          width: 100%;
        }
        .group-item-list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .pxToVw(width, 360);
            .pxToVw(min-height, 330);
            .pxToVw(padding, 20);
            background: #fbfbfb;
            box-sizing: border-box;
            .item-img {
              .pxToVw(width, 180);
              .pxToVw(height, 180);
              border-radius: 50%;
              background: #FFFFFF;
              border: 1px solid #CCCCCC;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                display: block;
                object-fit: contain;
                .pxToVw(width, 180);
                .pxToVw(height, 180);
              }
            }
            .item-info {
              width: 100%;
              text-align: center;
              overflow-wrap: anywhere;
            }
            .item-desc {
              .pxToVw(font-size, 18);
              .pxToVw(margin-top, 6);
              color: #666;
            }
            .item-name {
              .pxToVw(margin-top, 20);
              font-weight: 600;
              .pxToVw(font-size, 24);
              .pxToVw(line-height, 33);
              color: #333333;
            }
          }
        }
      }
    }
  }
}
</style>
